import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin } from "lucide-react";
import { CLASSES, IMAGES, priceLabel } from "@/data/classes";
import Seo from "@/components/Seo";

export default function Classes() {
  return (
    <div>
      <Seo
        title="All Classes"
        path="/classes"
        description="Browse all CPR, ACLS, PALS, BLS, Heartsaver, and workplace safety training courses offered by Rhythm Check Training in the DFW area."
      />
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
          <div className="font-mono-label text-[#d90429] mb-4">Our Programs</div>
          <h1 className="font-display text-5xl md:text-6xl font-black text-[#0a0a0a] leading-none">
            All classes.
            <br />
            <span className="text-[#d90429]">Equal focus.</span>
          </h1>
          <p className="mt-8 text-lg text-gray-700 max-w-2xl leading-relaxed">
            Whether you&apos;re a first responder, a medical practice, or a
            business protecting your team, we have a program built for you.
          </p>
        </div>
      </section>

      <section className="bg-[#f9fafb] py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-6">
          {CLASSES.map((c, idx) => (
            <div
              key={c.slug}
              data-testid={`class-list-item-${c.slug}`}
              className="grid lg:grid-cols-12 gap-8 items-center bg-white border border-gray-200 rounded-lg p-8 hover-lift"
            >
              <div className={`lg:col-span-4 ${idx % 2 ? "lg:order-2" : ""}`}>
                <img
                  src={IMAGES[c.imageKey]}
                  alt={c.name}
                  className="w-full h-56 object-cover rounded-md border border-gray-200"
                />
              </div>
              <div className="lg:col-span-8">
                <div className="font-mono-label text-[#d90429] mb-3">{c.code}</div>
                <h2 className="font-display text-3xl md:text-4xl font-black text-[#0a0a0a] leading-tight">
                  {c.name}
                </h2>
                <p className="mt-4 text-gray-700 leading-relaxed">{c.tagline}</p>
                <div className="mt-6 flex flex-wrap gap-6 text-sm text-gray-600">
                  <span className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#d90429]" /> {c.duration}</span>
                  <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#d90429]" /> DFW Area / On-site</span>
                  <span className="font-bold text-[#0a0a0a]">
                    {priceLabel(c)}
                  </span>
                </div>
                <div className="mt-8 flex flex-wrap gap-3">
                  <Link
                    to={`/classes/${c.slug}`}
                    data-testid={`class-details-link-${c.slug}`}
                    className="inline-flex items-center gap-2 rounded-md bg-[#0a0a0a] px-6 py-3 text-sm font-bold text-white hover:bg-[#d90429] transition-colors"
                  >
                    Class Details
                  </Link>
                  <Link
                    to={`/schedule?class=${c.slug}`}
                    data-testid={`class-signup-link-${c.slug}`}
                    className="inline-flex items-center gap-2 rounded-md border-2 border-[#d90429] px-6 py-3 text-sm font-bold text-[#d90429] hover:bg-[#d90429] hover:text-white transition-colors"
                  >
                    Sign Up <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
